module.exports = __webpack_public_path__ + "static/media/9.40623a30.svg";